<template>
  <div class="app-header">
    <div class="logo-wrap">
      <div class="logo"><img :src="$globalConfig.logo" class="logo-img"></div>
      <div class="title">{{$globalConfig.title}}</div>
      <i class="toggle-btn" :class="sideBarOpen ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="toggleSideBar"></i>
    </div>
    <slot name="app-menu"></slot>
    <div class="info">
      <div class="welcome">
        <img class="avatar" src="@/assets/img/avatar.png">{{$store.getters.userName}}
      </div>
      <el-badge :value="$store.getters.appUnhandledAlarmEventCount" title="新消息" class="msg">
        <img src="@/assets/img/icon_msg.png" @click="handleNewEventsClick">
      </el-badge>
      <div class="logout" title="注销登录" @click="logout">
        <img src="@/assets/img/icon_logout1.png">
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import AppHeader from './AppHeader.js'
export default AppHeader
</script>

<style lang="scss">
@import "AppHeader.scss";
</style>



// WEBPACK FOOTER //
// src/components/appHeader/AppHeader.vue